"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonRuleLibrary = void 0;
/**
 * A library of common rules that can be reused across different game levels
 */
var CommonRuleLibrary = /** @class */ (function () {
    function CommonRuleLibrary() {
    }
    /**
     * Moves entities toward their target positions
     *
     * Required components:
     * - x, y: Current position
     * - xTarget, yTarget: Target position
     * - moveToTargetRule: Boolean flag to enable this rule
     *
     * @param world The game world
     * @param ruleName The name to register this rule under (default: "moveToTargetRule")
     * @param description Optional custom description
     */
    CommonRuleLibrary.registerMoveToTargetRule = function (world, ruleName, description) {
        if (ruleName === void 0) { ruleName = "moveToTargetRule"; }
        if (description === void 0) { description = "Move x and y toward xTarget and yTarget"; }
        world.addRule(ruleName, description, function (world, moveToTargetRule, active, x, y, xTarget, yTarget) {
            for (var i = 0; i < world.maxActiveId; i++) {
                if (!active[i])
                    continue;
                if (!moveToTargetRule[i])
                    continue;
                if (xTarget[i] > x[i]) {
                    world.ecs.setEntityPosition(i, x[i] + 1, y[i]);
                }
                else if (xTarget[i] < x[i]) {
                    world.ecs.setEntityPosition(i, x[i] - 1, y[i]);
                }
                if (yTarget[i] > y[i]) {
                    world.ecs.setEntityPosition(i, x[i], y[i] + 1);
                }
                else if (yTarget[i] < y[i]) {
                    world.ecs.setEntityPosition(i, x[i], y[i] - 1);
                }
            }
        });
    };
    /**
     * Wander rule - makes entities move randomly
     *
     * Required components:
     * - x, y: Current position
     * - wanderRule: Boolean flag to enable this rule
     *
     * @param world The game world
     * @param ruleName The name to register this rule under (default: "wanderRule")
     * @param description Optional custom description
     * @param moveChance Chance of moving on each tick (0-1)
     */
    CommonRuleLibrary.registerWanderRule = function (world, ruleName, description, moveChance) {
        if (ruleName === void 0) { ruleName = "wanderRule"; }
        if (description === void 0) { description = "Move randomly around the map"; }
        if (moveChance === void 0) { moveChance = 0.2; }
        world.addRule(ruleName, description, function (world, wanderRule, active, x, y, xTarget, yTarget) {
            for (var i = 0; i < world.maxActiveId; i++) {
                if (!active[i])
                    continue;
                if (!wanderRule[i])
                    continue;
                // Only move sometimes
                if (Math.random() > moveChance)
                    continue;
                // Choose a random direction
                var direction = Math.floor(Math.random() * 4);
                // Calculate the target position based on the direction
                var newX = x[i];
                var newY = y[i];
                switch (direction) {
                    case 0: // Up
                        newY = Math.max(0, y[i] - 1);
                        break;
                    case 1: // Right
                        newX = Math.min(world.ecs.worldWidth - 1, x[i] + 1);
                        break;
                    case 2: // Down
                        newY = Math.min(world.ecs.worldHeight - 1, y[i] + 1);
                        break;
                    case 3: // Left
                        newX = Math.max(0, x[i] - 1);
                        break;
                }
                // Check if the target position is already occupied
                var entitiesAtTarget = world.ecs.getEntitiesAt(newX, newY);
                if (entitiesAtTarget.length === 0) {
                    xTarget[i] = newX;
                    yTarget[i] = newY;
                }
            }
        });
    };
    /**
     * Lifetime rule - entities die after a certain number of ticks
     *
     * Required components:
     * - lifetimeRule: Boolean flag to enable this rule
     * - lifetime: Int value representing remaining ticks before death
     *
     * @param world The game world
     * @param ruleName The name to register this rule under (default: "lifetimeRule")
     * @param description Optional custom description
     */
    CommonRuleLibrary.registerLifetimeRule = function (world, ruleName, description) {
        if (ruleName === void 0) { ruleName = "lifetimeRule"; }
        if (description === void 0) { description = "Decrease lifetime and deactivate when it reaches 0"; }
        world.addRule(ruleName, description, function (world, lifetimeRule, active, lifetime) {
            for (var i = 0; i < world.maxActiveId; i++) {
                if (!active[i])
                    continue;
                if (!lifetimeRule[i])
                    continue;
                // Decrease lifetime
                lifetime[i]--;
                // Deactivate if lifetime reaches 0
                if (lifetime[i] <= 0) {
                    active[i] = false;
                }
            }
        });
    };
    return CommonRuleLibrary;
}());
exports.CommonRuleLibrary = CommonRuleLibrary;
